import React, { Component } from "react";
import PropTypes from "prop-types";
import SearchMenu from "./SearchMenu";

import { Item } from "@zendeskgarden/react-menus";

import gql from "graphql-tag";
import { Query } from "react-apollo";

const brandsQuery = gql`
  query Brands($name: String) {
    brands(query: { name: $name }) {
      edges {
        node {
          id
          name
        }
      }
    }
  }
`;

export default class LabelMenu extends Component {
  static propTypes = {
    getItemProps: PropTypes.func.isRequired,
    focusedKey: PropTypes.string,
  };

  state = { searchText: "" };

  onSearchTextChanged = searchText => {
    this.setState({ searchText });
  };

  render() {
    const { searchText } = this.state;
    const { getItemProps, focusedKey } = this.props;

    return (
      <SearchMenu>
        <SearchMenu.Input onChange={this.onSearchTextChanged} />
        <Query
          query={brandsQuery}
          variables={{
            name: searchText,
          }}
        >
          {({ loading, error, data }) => {
            if (error) return <SearchMenu.SearchFailure />;

            const { brands = { edges: [], total: 0 } } = data;

            return (
              <SearchMenu.Items>
                {brands.edges.map(({ node: { id, name } }) => (
                  <Item
                    {...getItemProps({
                      key: `brand-${id}`,
                      focused: focusedKey === `brand-${id}`,
                    })}
                    data-test-id={`filter-menu-brand-item-${id}`}
                  >
                    {name}
                  </Item>
                ))}
              </SearchMenu.Items>
            );
          }}
        </Query>
      </SearchMenu>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/FilterMenu/BrandMenu.js